import React from 'react';
import {styled} from '@mui/material/styles';
import {Button, Typography, Container, Box} from '@mui/material';
import {useNavigate} from 'react-router-dom';
import {useMediaQuery} from '@mui/material';

const buttonStyles = {
  mt: {
    xs: 2,
    sm: 4,
  },
  color: 'white',
  background: theme => theme.palette.primary.main,
  fontSize: 16,
  borderRadius: 6,
  fontWeight: 600,
  width: {
    xs: '100%',
    sm: '300px',
  },
};

const ContentStyle = styled('div')(({theme}) => ({
  maxWidth: 600,
  margin: 'auto',
  minHeight: '80vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(0, 0),
}));

/**
 * React functional component representing the 404 Error Page.
 * @component
 * @returns {JSX.Element} The rendered Page404 component.
 */
export const Page404 = () => {
  const navigate = useNavigate();
  const isSmallScreen = useMediaQuery(theme => theme.breakpoints.down('sm'));
  return (
    <Box flex={18} p={2}>
      <Container>
        <ContentStyle sx={{textAlign: 'center', alignItems: 'center'}}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 600,
              textAlign: 'center',
              fontSize: isSmallScreen && 22,
              mb: 3,
            }}
          >
            Sorry, page not found!
          </Typography>

          <Typography sx={{color: 'text.secondary', paddingBottom: 2}}>
            Sorry, we couldn’t find the page you’re looking for. Perhaps you’ve mistyped the URL? Be sure to check your
            spelling.
          </Typography>
          <Button
            variant="contained"
            sx={buttonStyles}
            size="large"
            onClick={() => {
              navigate(-1);
            }}
          >
            Return to previous page
          </Button>
        </ContentStyle>
      </Container>
    </Box>
  );
};
